import { renderRoot } from 'quartz-core/client';
import Raven from 'raven-js';
import UIApplication from 'UIComponents/app/UIApplication';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import langShared from 'i2l?query=sporks!../lang/modules/academy-shared/en.lyaml';
import PublicAppRouter from './PublicAppRouter';
import { jsx as _jsx } from "react/jsx-runtime";
const URL_LANG = /.*\/([a-z]{2})\/.*/;
export default class PublicApplication {
  constructor(href = '') {
    const [__, locale] = href.match(URL_LANG) || [null, 'en'];
    this.locale = locale;
    const I18nPublicProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nPublicProvider.setLocale({
      locale,
      langEnabled: true
    });
    this.langAvailable = initAppTranslations([I18nPublicProvider.register(lang), I18nPublicProvider.register(langShared)]);
  }
  initRaven() {
    Raven.setUserContext({
      // @ts-expect-error leaving this same as it was set up in JS
      locale: this.locale
    });
  }
  start() {
    // https://product.hubteam.com/docs/frontend/docs/i18n/new-i18n-setup.html#publici18nprovider
    return this.langAvailable.then(() => {
      this.initRaven();
      this.startRouter();
    });
  }
  startRouter() {
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "LearningCenterUI",
      children: /*#__PURE__*/_jsx(PublicAppRouter, {})
    }));
  }
}